import CustomNotificationBanner from "../ui/CustomNotificationBanner/CustomNotificationBanner";

export function OtpBlockBanner({ countdown }) {
  return (
    <div className="mb-6 flex justify-center">
      <CustomNotificationBanner
        variant="error"
        title="OTP Verification Blocked"
        message={`Too many failed attempts. Try again in ${countdown}.`}
        withCloseButton={false}
        maw={440}
      />
    </div>
  );
}
